"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CancellationNoticeWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var commonFunctions_1 = require("../commonFunctions");
var services_1 = require("@falcon/services");
var CancellationNoticeWidget = /** @class */ (function (_super) {
    __extends(CancellationNoticeWidget, _super);
    function CancellationNoticeWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.pageTitle = _this.getSetting("pageTitle", undefined);
        return _this;
    }
    CancellationNoticeWidget.prototype.render = function () {
        var journeyState = this.props.engine.getJourneyState();
        var firstName = journeyState["driverFirstName"];
        var lastName = journeyState["driverLastName"];
        var interaction = this.props.interaction;
        if (interaction) {
            if (interaction.process === services_1.INTERACTION_PROCESS_MTA) {
                return (React.createElement("div", { className: "text-group" },
                    React.createElement("h1", null, this.pageTitle),
                    React.createElement("p", { className: "text-white" },
                        "Unfortunately we can't offer cover for ",
                        firstName,
                        " ",
                        lastName,
                        " due to changes you have made. We will continue to cover ",
                        firstName,
                        " ",
                        lastName,
                        " until ",
                        (0, commonFunctions_1.convertDate)(interaction.headerInfo.endDate, "DD MMMM YYYY"))));
            }
            else if (interaction.process === services_1.INTERACTION_PROCESS_MTC) {
                return (React.createElement("div", null,
                    React.createElement("div", { className: "text-group" },
                        React.createElement("h1", null, this.pageTitle),
                        React.createElement("p", { className: "text-white" }, "Unfortunately we can't cover you anymore. Your car cover will be cancelled in 7 days."))));
            }
            else if (interaction.process === services_1.INTERACTION_PROCESS_CHANGE_ADDRESS) {
                return (React.createElement("div", { className: "text-group" },
                    React.createElement("h1", null, this.pageTitle),
                    React.createElement("p", { className: "text-white" },
                        "Unfortunately we can't offer cover due to changes you have made. We will continue your cover until ",
                        (0, commonFunctions_1.convertDate)(interaction.headerInfo.endDate, "DD MMMM YYYY"))));
            }
            else {
                return React.createElement(React.Fragment, null);
            }
        }
        else {
            return null;
        }
    };
    return CancellationNoticeWidget;
}(plugin_journey_1.WidgetBase));
exports.CancellationNoticeWidget = CancellationNoticeWidget;
//# sourceMappingURL=CancellationNoticeWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/CancellationNoticeWidget.js
// module id = 3496
// module chunks = 0